import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'

const SELECTOR = 'a[href*="#"]:not([href="#todo"]):not([data-ref])'
export default class Page extends Component {
    prepare() {
        this.element.addEventListener('click', this.handleClick)

        if(document.querySelector('.article-Detail')) this.handleArticleTables()
    }

    handleClick = event => {
        if (event.defaultPrevented) {
            return
        }

        const id = event.target.closest(SELECTOR)?.href?.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        if (!element) {
            return
        }

        event.preventDefault()

        if (element.matches('.Section:not(.Section--appended):not(.Section--bare)')) {
            scrollToElement(element, {
                offset: 0
            })
        } else {
            scrollToElement(element)
        }
    }

    handleArticleTables = () => {
        let tables = document.querySelectorAll('.Table')
        tables.forEach((table) => {
            console.log(table);
            if (!table.parentNode.classList.contains('TableScroll')) {
                const newDivElement = document.createElement('div')
                newDivElement.classList.add('TableScroll')
                table.parentNode.insertBefore(newDivElement, table)
                newDivElement.appendChild(table)
            }
        })
    }
}
